import { types } from 'mobx-state-tree';


const NumberIdentifier = types.snapshotProcessor(types.identifierNumber, {
    preProcessor(snapshot) {
        // Allow strings but they must be number-like
        if (typeof snapshot === 'string') {
            return parseIntegerOrFail(snapshot);
        }

        return snapshot;
    },
});

function parseIntegerOrFail(integerString) {
    const integer = Number.parseInt(integerString);

    if (Number.isNaN(integer)) {
        return integerString; // allow MST to fail with error
    }

    return integer;
}

export default NumberIdentifier;
